import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import neuBirdLogo from "../assets/NeuBird-Horizontal-Default.svg";

const API_URL = process.env.REACT_APP_API_URL || "";

const SetPasswordComplete = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");

  useEffect(() => {
    const registrationId =
      searchParams.get("registration_id") ||
      localStorage.getItem("earlybird_registration_id");

    if (!registrationId) {
      setError("Missing registration information. Please register again.");
      return;
    }

    localStorage.setItem("earlybird_registration_id", registrationId);

    const confirmPassword = async () => {
      try {
        await axios.post(
          `${API_URL}/earlybird/confirm-password`,
          { registration_id: registrationId },
          { headers: { "Content-Type": "application/json" } }
        );
        navigate("/registrations/provisioning");
      } catch (err) {
        console.error("Confirm password error:", err);
        setError("Something went wrong. Please try again or contact support.");
      }
    };

    confirmPassword();
  }, [searchParams, navigate]);

  return (
    <>
      <nav className="site-nav">
        <a className="nav-logo" href="https://neubird.ai">
          <img src={neuBirdLogo} alt="NeuBird AI" />
        </a>
      </nav>

      <div className="success-page">
        <div className="success-card">
          {error ? (
            <>
              <div className="success-icon" style={{ background: "rgba(231,76,60,0.15)", color: "#e74c3c" }}>!</div>
              <h2>Something went wrong</h2>
              <p>{error}</p>
              <p style={{ marginTop: "1rem" }}>
                <a href="/registrations" style={{ color: "var(--sunset)", fontWeight: 600 }}>
                  Back to registration
                </a>
              </p>
            </>
          ) : (
            <>
              <div className="success-icon">&#10003;</div>
              <h2>Password set!</h2>
              <p>Setting up your NewBird workspace...</p>
            </>
          )}
        </div>
      </div>

      <footer className="site-footer">
        <span className="footer-text">&copy; 2026 NeuBird AI, Inc.</span>
        <div className="footer-links">
          <a href="https://neubird.ai/privacy" target="_blank" rel="noopener noreferrer">Privacy</a>
          <a href="https://neubird.ai/terms" target="_blank" rel="noopener noreferrer">Terms</a>
          <a href="https://neubird.ai/security" target="_blank" rel="noopener noreferrer">Security</a>
          <a href="https://neubird.ai/contact" target="_blank" rel="noopener noreferrer">Contact</a>
        </div>
      </footer>
    </>
  );
};

export default SetPasswordComplete;
